<template>
  <div class="ls-header" id="lsHeader">
    <nav class="navbar" role="navigation">
      <div class="container container2">
        <div class="container-fluid">
          <div class="navbar-header">
            <button type="button" class="navbar-toggle" data-toggle="collapse"
              data-target="#bs-example-navbar-collapse-1">
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <a class="" href="#/index">
              <div class="logo"></div>
            </a>
          </div>
          <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
            <ul class="nav navbar-nav">
            </ul>
            <ul class="nav navbar-nav navbar-right">
              <li>
                <div class="ls-button" @click="handleToPath('/release_need')">客户大厅</div>
              </li>
              <li>
                <div class="ls-button" @click="handleToDatabee">
                  数据蜂广场</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  name: "LsHeader",
  inject: ['reload'],
  data () {
    return {}
  },
  methods: {
    handleToPath (path) {
      if (location.href.includes(path)) {
        this.reload()
        // location.reload()
      } else {
        this.$router.push(path)
      }

    },
    handleToDatabee () {
      if (location.origin.includes('test')) {
        window.open('https://testnsrc.databeehub.cn/dist/index.html#/user/index')
      } else {
        window.open('https://nsrc.databeehub.cn/dist/index.html#/user/index')
      }
    }
  }
}
</script>
<style scoped>
.ls-header {}

.ls-header .navbar {
  margin-bottom: 0;
  border: 0;
  padding: 20px 0;
  /* padding-top: 27px; */
}

.ls-header .logo {
  width: 165px;
  height: 46px;
  background: url(../assets/images/logo.png);
}

.ls-header .navbar-toggle span {
  background: #fff;
}


@media (max-width:768px) {
  .ls-button:first-child {
    margin-bottom: 12px;
  }
}


@media (min-width:1200px) and (max-width:1600px) {
  /* .container2 {
    width: 1000px;
  } */
}
</style>


// WEBPACK FOOTER //
// src/components/LsHeader.vue